import PersonDetails, {Record} from "./ItemDetails";

export default PersonDetails;

export {Record};